// extracted by mini-css-extract-plugin
export default {"input-options-selected":"MultipleTextInput_input-options-selected__essl5"};